export enum DepartureCommentType {
  COMMENT = 'COMMENT',
  ATTACHMENT_UPDATE = 'ATTACHMENT_UPDATE',
  CONFIDENTIALITY_CLEARED = 'CONFIDENTIALITY_CLEARED',
}
